import { GetterTree } from "vuex";
import { TeacherTeachingState } from "./state";
import { defineVuexName, MODULES } from "@/store/utils";

const getters: GetterTree<TeacherTeachingState, any> = {
  //getIndependentListStudentItems
  [defineVuexName(MODULES.TEACHER_TEACHING.GETTERS.GET_INDEPENDENT_LIST_STUDENT_ITEMS)](s: TeacherTeachingState) {
    return s.independentListStudentItems;
  },
};

export default getters;
